/**
 * SQL 템플릿(스니펫) — 자동완성에서 짧은 약어로 문형을 펼친다. (Phase 3)
 *
 * 예: `sf` → `SELECT * FROM ⟨table⟩` (⟨⟩ 자리는 Tab 으로 순회)
 *
 * 템플릿 문법은 CodeMirror 의 snippet 규격을 따른다 — `${이름}` 이 채울 자리.
 * 사용자가 편집한 목록은 appSettings 의 `snippets` 섹션(배열)에 저장된다.
 */
/* eslint-disable no-template-curly-in-string --
   ${이름} 은 CodeMirror 스니펫 문법이라 문자열 그대로 보존해야 한다. */
import { loadSection, saveSection } from './appSettings';

/** 기본 제공 템플릿 — 자주 쓰는 문형 위주. */
export const DEFAULT_SNIPPETS = [
  { label: 'sf',  detail: 'SELECT * FROM',          template: 'SELECT * FROM ${table}' },
  { label: 'sfw', detail: 'SELECT * FROM ~ WHERE',  template: 'SELECT * FROM ${table}\nWHERE ${condition}' },
  { label: 'cnt', detail: 'SELECT COUNT(*)',        template: 'SELECT COUNT(*) FROM ${table}' },
  { label: 'ins', detail: 'INSERT INTO',            template: 'INSERT INTO ${table} (${columns})\nVALUES (${values})' },
  { label: 'upd', detail: 'UPDATE ~ SET ~ WHERE',   template: 'UPDATE ${table}\nSET ${column} = ${value}\nWHERE ${condition}' },
  { label: 'del', detail: 'DELETE FROM ~ WHERE',    template: 'DELETE FROM ${table}\nWHERE ${condition}' },
  { label: 'jn',  detail: 'JOIN ~ ON',              template: 'JOIN ${table} ${alias} ON ${condition}' },
  { label: 'lj',  detail: 'LEFT JOIN ~ ON',         template: 'LEFT JOIN ${table} ${alias} ON ${condition}' },
  { label: 'gb',  detail: 'GROUP BY ~ HAVING',      template: 'GROUP BY ${columns}\nHAVING ${condition}' },
  { label: 'wth', detail: 'WITH (CTE)',             template: 'WITH ${name} AS (\n    ${query}\n)\nSELECT * FROM ${name}' },
  { label: 'ct',  detail: 'CREATE TABLE',           template: 'CREATE TABLE ${table} (\n    ${column} ${type}\n)' },
];

/** 한 항목이 쓸 만한지 — 빈 약어/본문은 자동완성에서 의미가 없다. */
function isValid(sn) {
  return !!sn
    && typeof sn.label === 'string' && sn.label.trim() !== ''
    && typeof sn.template === 'string' && sn.template.trim() !== '';
}

// 자동완성이 호출될 때마다 localStorage 를 파싱하지 않도록 캐시한다.
// 저장/초기화 시에만 무효화 — 단일 창 앱이라 외부 변경을 신경 쓰지 않아도 된다.
let _cache = null;

/** 저장된 템플릿 목록 (없으면 기본값). 항상 유효한 항목만 돌려준다. */
export function loadSnippets() {
  if (_cache) return _cache;
  const saved = loadSection('snippets');
  if (!Array.isArray(saved)) { _cache = DEFAULT_SNIPPETS.map(s => ({ ...s })); return _cache; }
  const cleaned = saved.filter(isValid).map(s => ({
    label: String(s.label).trim(),
    detail: typeof s.detail === 'string' ? s.detail : '',
    template: String(s.template),
  }));
  _cache = cleaned;
  return _cache;
}

/** 목록 저장 — 유효하지 않은 항목은 걸러서 저장한다. */
export function saveSnippets(list) {
  const cleaned = (Array.isArray(list) ? list : []).filter(isValid).map(s => ({
    label: String(s.label).trim(),
    detail: typeof s.detail === 'string' ? s.detail : '',
    template: String(s.template),
  }));
  saveSection('snippets', cleaned);
  _cache = cleaned;
  return cleaned;
}

/** 기본값으로 되돌리기 */
export function resetSnippets() {
  const d = DEFAULT_SNIPPETS.map(s => ({ ...s }));
  saveSection('snippets', d);
  _cache = d;
  return d;
}
